import { Routes } from "./models/routes";
import * as routeName from "./routeNameAuthType";
import { HomePage } from "../pages/home/HomePage";

const routes: Routes = {
  list: [
    {
      path: "/home",
      component: HomePage,
      name: routeName.home,
      icon: "list",
    },
  ],
  redirect: routeName.redirectPath,
  firstPage: routeName.firstPage,
};
export default routes;
